import { createSlice } from "@reduxjs/toolkit";

export const authSlice = createSlice({
  name: "auth",
  initialState: {
    status: "not-authenticated",
    role: null,
    changePassword: false,
    avatar: "user",
    isActive: false,
    urlDocuments: null,
    id: null,
    investmentType: null,
  },
  reducers: {
    login: (state, { payload }) => {
      state.status = "authenticated";
      state.role = payload.user.role;
      state.changePassword = payload.user.needPassword;
      state.avatar = payload.user.avatar;
      state.isActive = payload.user.isActive;
      state.urlDocuments = payload.user.urlDocuments;
      state.id = payload.user.id;
      state.investmentType = payload.user.investmentType;
    },
    checkingCredentials: (state) => {
      state.status = "checking";
    },
    logout: (state) => {
      state.status = "not-authenticated";
      state.role = null;
      state.changePassword = false;
      state.avatar = "user";
      localStorage.removeItem("token");
      sessionStorage.removeItem("token");
      state.urlDocuments = null;
      state.id = null;
      state.investmentType = null;
    },
    openModalChangePassword: (state) => {
      state.changePassword = true;
    },
    closeModalChangePassword: (state) => {
      state.changePassword = false;
    },
  },
});

export const {
  login,
  checkingCredentials,
  logout,
  openModalChangePassword,
  closeModalChangePassword,
  updateUser,
} = authSlice.actions;
